import {
  useHtzVisualAssessmentCatalogShowActiveCatalogQuery,
  useHtzVisualAssessmentCatalogShowQuery,
} from "@/services/backend/htz/inspection/api/visual-assessment-catalog-api";

/**
 * useActiveVisualAssessmentCatalog loads the catalog of visual assessments which is active for the company.
 * The catalog is undefined while it loads or when the company has no active
 * catalog.
 */
export function useActiveVisualAssessmentCatalog(companyId: string) {
  const {
    data: activeCatalog,
    isLoading: activeCatalogIsLoading,
    error: activeCatalogError,
  } = useHtzVisualAssessmentCatalogShowActiveCatalogQuery(
    { companyId },
    { skip: !companyId },
  );

  const {
    data: catalog,
    isLoading: catalogIsLoading,
    error: catalogError,
  } = useHtzVisualAssessmentCatalogShowQuery(
    { id: activeCatalog?.catalogId ?? "" },
    {
      skip: activeCatalog === undefined || activeCatalog.catalogId === null,
    },
  );

  return {
    data: catalog,
    isLoading: activeCatalogIsLoading || catalogIsLoading,
    error: activeCatalogError || catalogError,
  };
}
